import { render, staticRenderFns } from "./InfinityScroll.vue?vue&type=template&id=94b3f7f2&"
import script from "./InfinityScroll.vue?vue&type=script&lang=js&"
export * from "./InfinityScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports